import {Injectable} from '@angular/core';
import {Customer} from '@mydocma/customer';
import {Project} from '@mydocma/project';
import {ProjectUserPermissions} from '@docma-mm-core/permission/project-user-permissions';

@Injectable({ providedIn: 'root' })
export class MmRoutingDataService {
  customers?: Customer[];
  currentCustomer?: Customer;
  currentProject?: Project;
  projectPermissions?: ProjectUserPermissions;  // {[ProjectId: string]: ProjectUserPermissions};
}
